export default "__VITE_ASSET__FCLy8gJP__"